import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const IndividualCorporateTrainings = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="IndividualCorporateTrainings" />
                    <HerosectionsAll ScreenName="Individual Corporate Trainings" ScreenSearch="indivisual" />
                    <div className="row col-lg-9 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 faint py-4 px-3" style={{ textAlign: 'justify'}}>
                            <h5 className="fw-bold gray_color pb-3">Individual Corporate Trainings</h5>

                            <p> We customise training sessions based on training need analysis techniques like De Bone analysis, five wheeling technique etc.
                                <br />
                                We use blended training methods in which students/trainees learn through both electronic/online media and conventional face-to-face interaction. </p>

                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
